'use strict';

namespace Core {

    class CountBadge {

        count: number;
        private output: string;

        constructor (
            private $scope: ng.IScope
        ) {
            this.$scope.$watch('cb.count', (val) => {
                if (val) {
                    this.output = val < 10
                        ? val.toString()
                        : '9+';
                }
            });
        }
    }

    angular
        .module('core')
        .directive('countBadge', (): ng.IDirective => {
            return {
                scope: {},
                controller: CountBadge,
                controllerAs: 'cb',
                bindToController: {
                    count: '='
                },
                template: `<span class="sc-c-badge">{{cb.output}}</span>`,
                replace: true
            };

        });

}
